export default __webpack_public_path__ + "static/media/media__item-img-20.e9e16283.png";